import { ComponentProps } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import { styled } from "~/application/theme";

export type SidebarContentProps = ComponentProps<typeof SidebarContent>;

export const SidebarContent = styled(DialogPrimitive.Content, {
  position: "fixed",
  top: 0,
  height: "100vh",
  "@supports (height: 100dvh)": {
    height: "100dvh",
  },
  backgroundColor: "$neutrals-white",
  zIndex: "$sidebar",
  overflow: "hidden",
  "@mmd": {
    width: "100%",
    left: 0,
    right: "auto",
  },
});
